import React from "react";

export default function AdminHeader() {
  return (
    <div className="admin-header">
      <h1 className="admin-title">Admin Dashboard</h1>
      <p className="admin-subtitle">
        Manage your shop products and view analytics
      </p>
    </div>
  );
}
